import i18n from './i18n'

export const __ = (key, values) => {
    const result = i18n.t(key, values)
    if (typeof result === 'object') {
        if (values.count === 1) {
            return result?.one?.replace('%s', values.count)
        }
        return result?.other?.replace('%s', values.count)
    }
    if (values && Object.keys(values).length) {
        return Object.keys(values).reduce((p, c) => p.replaceAll(`{${c}}`, values[c]), result)
    }
    return result
}

export default i18n
